import React from 'react';
import { Button, Text } from 'v3/components';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import CheckCircleOutlineOutlinedIcon from '@mui/icons-material/CheckCircleOutlineOutlined';
import AssignmentTurnedInOutlinedIcon from '@mui/icons-material/AssignmentTurnedInOutlined';
import CalendarTodayOutlinedIcon from '@mui/icons-material/CalendarTodayOutlined';
import WarningAmberOutlinedIcon from '@mui/icons-material/WarningAmberOutlined';

function renderPlateDisplay(label) {
  const text = String(label || '').trim();
  if (!text) return null;

  const parts = text.split(/\s*[|/]\s*/).filter(Boolean);

  return parts.map((part, index) => {
    const colonIndex = part.indexOf(':');
    if (colonIndex === -1) {
      return (
        <React.Fragment key={`${part}-${index}`}>
          {index > 0 && ' | '}
          <strong>{part.trim()}</strong>
        </React.Fragment>
      );
    }

    const prefix = part.slice(0, colonIndex + 1);
    const value = part.slice(colonIndex + 1).trim();

    return (
      <React.Fragment key={`${prefix}-${value}-${index}`}>
        {index > 0 && ' | '}
        <span>{prefix} </span>
        <strong>{value}</strong>
      </React.Fragment>
    );
  });
}


export default function AnsweredCard({
  item,
  styles,
  onViewAnswers,
}) {

  const expiredDays = item.expiredDays;
  const daysSinceCreated = item.daysSinceCreated;
  const isExpired = item.isExpired;
  const responseOrigin = item?.responseOrigin === 'external' ? 'external' : 'internal';

  return (
    <div style={styles.itemCard('answered')}>
      <div style={styles.itemLeft}>
        <div style={styles.itemIcon('answered')}>
          <AssignmentTurnedInOutlinedIcon style={{ fontSize: 18 }} />
        </div>

        <div style={styles.itemContent}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12, width: '100%' }}>
            <div style={{ ...styles.itemTitle, flex: 1, minWidth: 0 }}>{`#${item.id} ${item.title}`}</div>
            <span style={styles.responseOriginPill(responseOrigin)}>
              {responseOrigin === 'external' ? 'EXTERNO' : 'INTERNO'}
            </span>
          </div>

          <div style={styles.itemDesc}>{item.description}</div>

          <div style={styles.metaRow}>
            {!!item.team && <span style={{ fontWeight: 700 }}>👥 {item.team}</span>}
          </div>
          {!!item?.plateDisplayLabel && (
            <div style={{ marginTop: 2, fontSize: 13, color: '#374151', fontWeight: 400 }}>
              {renderPlateDisplay(item.plateDisplayLabel)}
            </div>
          )}

          <div style={styles.metaRow}>
            {!!item.requestedBy && (
              <span>
                👤 Criado por: {item.requestedBy} em {item.requestedAt}
              </span>
            )}

            <span style={styles.metaStatus(isExpired)}>
              {isExpired ? (
                <>
                  <CalendarTodayOutlinedIcon style={{ fontSize: 16 }} />
                  <WarningAmberOutlinedIcon style={{ fontSize: 16 }} />
                </>
              ) : (
                <CalendarTodayOutlinedIcon style={{ fontSize: 16 }} />
              )}
              {isExpired
                ? `Vencido há ${expiredDays} ${expiredDays === 1 ? 'dia' : 'dias'}`
                : item.createdAgoLabel || `Criado há ${daysSinceCreated ?? 0} dias`}
            </span>

            {item.questionsCount > 0 && (
              <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}>
                <CheckCircleOutlineOutlinedIcon style={{ fontSize: 16, color: '#16A34A' }} />
                <span style={{ color: '#16A34A', fontWeight: 600 }}>
                  {item.questionsCount} itens respondidos
                </span>
              </span>
            )}
          </div>

          <div style={{ marginTop: 8, display: 'flex', alignItems: 'center', width: '100%', gap: 12 }}>
            <span style={{ fontSize: 12, color: '#6B7280', flex: 1, minWidth: 0 }}>
              Respondido por <strong>{item.answeredBy}</strong> em {item.answeredAtLabel}
            </span>

            <div style={{ marginLeft: 'auto', flexShrink: 0 }}>
              <Button variant="secondary" onClick={() => onViewAnswers?.(item)}>
                <div style={styles.actionBtnInner}>
                  <VisibilityOutlinedIcon style={{ fontSize: 16 }} />
                  <Text type="regular" weight={600}>
                    Visualizar
                  </Text>
                </div>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
